import { CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { map, of, tap } from "rxjs";
import { UserAuthorityEnum } from "../../services/user-authority/model/user-authority-enum.model";
import { UserAuthorityService } from "../../services/user-authority/service/user-authority.service";
import { JwtService } from "../../services/auth/jwt.service";
import { forceLogout } from "./auth.guard.utils";

export const authGuard: CanActivateFn = (_, state) => {
	const userAuthorityService = inject(UserAuthorityService);
	const jwtService = inject(JwtService);
	const router = inject(Router);

	const tokenId = jwtService.getCurrentTokenId();

	if (!tokenId) {
		forceLogout(state, router, jwtService);
		return of(false);
	}

	return userAuthorityService.getAuthorities().pipe(
		tap({
			next: authorities => {
				if (!authorities?.length) forceLogout(state, router, jwtService, "not_authorized");

				if (authorities?.includes(UserAuthorityEnum.GLOBAL_BACKOFFICE))
					void router.navigate(["/admin"]);
			},
			error: error => forceLogout(state, router, jwtService, error?.message)
		}),
		map(authorities => !authorities?.includes(UserAuthorityEnum.GLOBAL_BACKOFFICE))
	);
};
